module.exports = {
	DATA_TOPIC: [

	]
}


//////////////////
// WEBPACK FOOTER
// ./config/topic.js
// module id = lMZ4
// module chunks = 55